<template>
  <div v-if="$page" class="involve">
    <header class="header -column">
      <h1 v-reveal="{ delay: 550 }" class="header__subtitle">{{ $page.header.hat }}</h1>
      <p v-reveal="{ delay: 600 }" class="header__title">{{ $page.header.title }}</p>
    </header>

    <section v-reveal="{ delay: 650 }" class="section -first -flower">
      <div class="involve__header">
        <div class="row__item -span-7">
          <h2 v-reveal="{ delay: 700 }" class="section__title">{{ $page.partners.title }}</h2>

          <RawHtml v-if="$page.partners.description" :html="$page.partners.description" />

          <div id="qui">
            <h2 class="section__subtitle">{{ $page.partners.who.title }}</h2>
            <RawHtml v-if="$page.partners.who.description" :html="$page.partners.who.description" />
          </div>
        </div>

        <img src="@/assets/images/home-program.svg" class="involve__header-image" alt="" />
      </div>

      <div id="pourquoi">
        <h3 class="section__subtitle">{{ $page.partners.why.title }}</h3>
        <div class="row">
          <div class="row__item -span-6">
            <RawHtml
              v-if="$page.partners.why.description.left"
              :html="$page.partners.why.description.left"
            />
          </div>
          <div class="row__item -span-5 -skip-1">
            <RawHtml
              v-if="$page.partners.why.description.right"
              :html="$page.partners.why.description.right"
            />
          </div>
        </div>
      </div>

      <div>
        <Blob shape="b" squish light bottom />
        <h3 class="section__subtitle">{{ $page.partners.members.title }}</h3>
        <div class="row -spread">
          <div
            v-for="(memberType, memberTypeKey) in $page.partners.members.items"
            :key="memberTypeKey"
            class="involve__members__item"
          >
            <Image v-if="memberType.image" :source="memberType.image" class="icon" />
            <h4 class="involve__members__item-title">
              <span class="involve__members__item__amount">{{ memberType.amount }}</span
              >{{ memberType.name }}
            </h4>
            <RawHtml v-if="memberType.description" :html="memberType.description" />
            <RouterLink :to="memberType.link" class="section__link involve__members__item-link">
              <span>{{ memberType.label }}</span>
              <Icon id="leaves" class="leaves" />
            </RouterLink>
          </div>
        </div>
      </div>

      <div class="row -align-center">
        <Image
          v-if="$page.ambassador.image"
          :source="$page.ambassador.image"
          alt="site"
          style="width: 450px; height: auto; max-width: 100%"
        />
        <div style="padding-left: 3rem">
          <h2 v-reveal="{ delay: 100 }" class="section__title">{{ $page.ambassador.title }}</h2>
          <RawHtml
            v-if="$page.ambassador.description"
            :html="$page.ambassador.description"
            v-reveal="{ delay: 100 }"
          />
        </div>
      </div>
    </section>

    <CtaContactSection
      v-reveal="{ delay: 100 }"
      :title="$page.contact.title"
      :subtitle="$page.contact.description"
      :link-label="$page.contact.label"
      route-name="program"
    />
  </div>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import RawHtml from '@/components/global/RawHtml.vue'
import Blob from '@/components/graphics/Blob.vue'
import Statistic from '@/components/partials/Statistic.vue'
import CtaContactSection from '@/components/sections/CtaContactSection.vue'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Involve',
  beetPage: 'involved',
  mixins: [PageMetaMixin],
  components: {
    Image,
    RawHtml,
    CtaContactSection,
    Blob,
    Icon,
    Statistic,
  },
}
</script>
